import React, { useEffect, useRef } from "react";

export default function ReportFilterPanel({ children }) {
  const panelRef = useRef(null);

  useEffect(() => {
    const panel = panelRef.current;
    const report = panel?.closest(".form-wrapper");
    if (!panel || !report) return undefined;

    const collapseAfterFilter = (event) => {
      if (event.target.closest(".report-actions-row .btn-primary")) {
        panel.removeAttribute("open");
      }
    };

    report.addEventListener("click", collapseAfterFilter);
    return () => report.removeEventListener("click", collapseAfterFilter);
  }, []);

  return (
    <details ref={panelRef} className="report-filters" open>
      <summary className="report-filters__summary">
        <span className="report-filters__summary-title">
          <i className="fas fa-sliders-h" aria-hidden="true" />
          Filters
        </span>
        <span className="report-filters__summary-action report-filters__summary-action--open">
          Hide filters
        </span>
        <span className="report-filters__summary-action report-filters__summary-action--closed">
          Show filters
        </span>
        <i
          className="fas fa-chevron-up report-filters__chevron"
          aria-hidden="true"
        />
      </summary>
      <div className="report-filters__body">{children}</div>
    </details>
  );
}
